module.exports = __webpack_public_path__ + "resources/icon-dialog-role-check.118be0ae515a74b1.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/component/lottery-dialog-role/img/icon-dialog-role-check.png
// module id = 819
// module chunks = 0 1